import { Component, OnInit, Input } from '@angular/core';
import { LevelLayout } from '../../model/layout/Level.layout';
import { Level } from '../../model/interfaces';
import { CvdsUtilsService } from '../../service';

@Component({
	selector: 'cv-cvds-level',
	templateUrl: './cvds-level.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsLevelComponent implements OnInit {
	@Input() level: Level;
	@Input() index: number;

	constructor(private utilsService: CvdsUtilsService) {}

	fieldsModel = [];
	fieldsSections = [];

	async ngOnInit(): Promise<void> {
		const layout = new LevelLayout();
		this.fieldsModel = this.utilsService.mapFields(this.level, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.level, fieldName)) {
				this.fieldsSections.push({
					items: this.level[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
